import {NgModule} from '@angular/core';
import {GnVideoComponent} from './video.component';
import {GnCameraComponent} from './camera.component';


@NgModule({
  declarations: [GnVideoComponent, GnCameraComponent],
  exports: [
    GnCameraComponent,
    GnVideoComponent
  ],
  imports: [],
  entryComponents: []
})
export class GnMediaModule {
}
